import React from 'react';
import { SelectOption, SelectOptionWrapper, Space } from './styles';
import Chevron from '../Chevron';
import Icon from '../Icon/Icon';
import { darkGreen } from '../../utils/style/colors';

interface IComponentProps {
  label: string;
  disabled?: boolean;
  isActive: boolean;
  expand?: (value: string | number, expanded: boolean) => void;
  expandable?: boolean;
  depth?: number;
  value: string | number;
  expanded?: boolean;
  onUpdatePointer: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
  onSelectAOption: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
  inTree: boolean;
  selected: boolean;
  selectionIndicator: boolean;
  multiChoice: boolean;
}

class SelectOptionItem extends React.Component<IComponentProps> {
  shouldComponentUpdate(nextProps: IComponentProps) {
    if (
      this.props.label === nextProps.label &&
      this.props.isActive === nextProps.isActive &&
      this.props.expanded === nextProps.expanded &&
      this.props.selected === nextProps.selected
    ) {
      return false;
    }
    return true;
  }
  render() {
    const {
      label,
      isActive,
      onUpdatePointer,
      onSelectAOption,
      expandable,
      expanded,
      expand,
      value,
      depth,
      inTree,
      selected,
      selectionIndicator,
      multiChoice,
      disabled,
    } = this.props;
    return (
      <SelectOptionWrapper>
        <Space depth={!inTree ? 0 : (depth ?? 0) + (expandable ? 0 : 1)} />
        {expandable && (
          <Chevron
            isOpen={!!expanded}
            onClick={() => expand!(value, !expanded)}
            style={{ margin: '5px' }}
          />
        )}
        <SelectOption
          selected={selected}
          active={isActive}
          onClick={
            !disabled
              ? onSelectAOption
              : expandable
                ? () => expand!(value, !expanded)
                : () => {
                    /*do nothing*/
                  }
          }
          onMouseOver={onUpdatePointer}
          selectionIndicator={selectionIndicator}
          disabled={disabled && !expandable}
        >
          <div
            style={{
              maxWidth: '100%',
              whiteSpace: 'normal',
              textAlign: 'start',
            }}
          >
            {label}
          </div>
          <input type={'checkbox'} defaultChecked={selected} />
          <div style={{ flex: 1 }} />
          {selectionIndicator ? (
            multiChoice ? (
              selected ? (
                <Icon type={'check-square'} color={darkGreen} />
              ) : (
                <Icon type={'square'} color={'rgba(0, 0, 0, 0.3)'} />
              )
            ) : selected ? (
              <Icon type={'circle'} color={'#00897B'} />
            ) : null
          ) : null}
        </SelectOption>
      </SelectOptionWrapper>
    );
  }
}

export default SelectOptionItem;
